import FadeLoader from "react-spinners/FadeLoader";

const override = {
    display: "block",
    margin: "15px auto",
    borderColor: "red",
    position: 'absolute',
    top: '50%',
    left: '50%',
};

const SaveLoading = ({ loading }) => {
    return (
            <FadeLoader className='mr-1' color={'#292E4C'}
                loading={loading}
                cssOverride={override}
                size={35}
                aria-label="Loading Spinner"
                data-testid="loader"
            />    )
}

export default SaveLoading;